import tokens from '@audi/audi-ui-design-tokens';
export const responsiveSpacingTokens = {
    xxs: {
        xs: tokens.SPACING_XXS_XS,
        s: tokens.SPACING_XXS_S,
        m: tokens.SPACING_XXS_M,
        l: tokens.SPACING_XXS_L,
        xl: tokens.SPACING_XXS_XL,
        xxl: tokens.SPACING_XXS_XXL,
    },
    xs: {
        xs: tokens.SPACING_XS_XS,
        s: tokens.SPACING_XS_S,
        m: tokens.SPACING_XS_M,
        l: tokens.SPACING_XS_L,
        xl: tokens.SPACING_XS_XL,
        xxl: tokens.SPACING_XS_XXL,
    },
    s: {
        xs: tokens.SPACING_S_S,
        s: tokens.SPACING_S_S,
        m: tokens.SPACING_S_M,
        l: tokens.SPACING_S_L,
        xl: tokens.SPACING_S_XL,
        xxl: tokens.SPACING_S_XXL,
    },
    m: {
        xs: tokens.SPACING_M_S,
        s: tokens.SPACING_M_S,
        m: tokens.SPACING_M_M,
        l: tokens.SPACING_M_L,
        xl: tokens.SPACING_M_XL,
        xxl: tokens.SPACING_M_XXL,
    },
    l: {
        xs: tokens.SPACING_L_S,
        s: tokens.SPACING_L_S,
        m: tokens.SPACING_L_M,
        l: tokens.SPACING_L_L,
        xl: tokens.SPACING_L_XL,
        xxl: tokens.SPACING_L_XXL,
    },
    xl: {
        xs: tokens.SPACING_XL_S,
        s: tokens.SPACING_XL_S,
        m: tokens.SPACING_XL_M,
        l: tokens.SPACING_XL_L,
        xl: tokens.SPACING_XL_XL,
        xxl: tokens.SPACING_XL_XXL,
    },
    xxl: {
        xs: tokens.SPACING_XXL_S,
        s: tokens.SPACING_XXL_S,
        m: tokens.SPACING_XXL_M,
        l: tokens.SPACING_XXL_L,
        xl: tokens.SPACING_XXL_XL,
        xxl: tokens.SPACING_XXL_XXL,
    },
    xxxl: {
        xs: tokens.SPACING_XXXL_S,
        s: tokens.SPACING_XXXL_S,
        m: tokens.SPACING_XXXL_M,
        l: tokens.SPACING_XXXL_L,
        xl: tokens.SPACING_XXXL_XL,
        xxl: tokens.SPACING_XXXL_XXL,
    },
};
export const spacingLabels = Object.keys(responsiveSpacingTokens);
//# sourceMappingURL=audi-spacing.js.map